export default __webpack_public_path__ + "static/media/asterx-1.27e7d4bf.png";